import axios from 'axios'
import config from '../utils/config'
import commonStore from '../stores/commonStore'
import errorStore from '../stores/errorStore'

const instance = axios.create({
  baseURL: config.apiUrl,
  // timeout: 1000,
  withCredentials: false,
  headers: {
    'access-token': config.apiKey,
    'Access-Control-Allow-Origin': '*'
  }
})

// adds the authorization header to the requests
const addAuthHeader = config => {
  const configWAuthHeader = {...config}
  configWAuthHeader.headers['authorization'] = commonStore.token
  return configWAuthHeader
}
instance.interceptors.request.use(addAuthHeader)

const handleErrors = err => {
  err && err.response && err.response.data && errorStore.displayError(err.response.data.message)
  throw err
}

const responseBody = res => res.data.data

const requests = {
  del: url =>
    instance.delete(url)
      .then(responseBody)
      .catch(handleErrors),

  get: (url, params = {}) =>
    instance.get(url, {params})
      .then(responseBody)
      .catch(handleErrors),

  put: (url, body) =>
    instance.put(url, body)
      .then(responseBody)
      .catch(handleErrors),

  post: (url, body, disableError) =>
    instance.post(url, body)
      .then(responseBody)
      .catch(err => !disableError && handleErrors(err)),
}

export default requests



// WEBPACK FOOTER //
// ./src/api/requests.js